// extracted by mini-css-extract-plugin
export default {"loader-container":"loaderPage_loader-container__0zfEr","loader-page":"loaderPage_loader-page__tKZ-5","loader-text":"loaderPage_loader-text__CeDFU"};